<template>
  <div>
    <!-- 联系我们 -->
    <section class="advertise-section section pb0">
      <div class="img-wrap">
        <img :src="$store.state.screenWidth > 768 ? advertiseImg : advertiseMobileImg" alt="" />
      </div>
      <div class="content">
        <h4 v-html="contactTxt"></h4>
        <el-button type="primary" @click="jumpRoute('/contact')">
          {{ contactBtnTxt }}
        </el-button>
      </div>
    </section>

    <div class="footer-wrap">
      <footer class="footer w-page2 section2">
        <div class="footer-top d-flex">
          <div class="logo cussor-pointer">
            <img src="@/assets/images/login/login-logo.png" alt="" />
            <div class="copyright">
              © 2026 XPIRORY PTE. LTD. All rights reserved
            </div>
          </div>
          <div class="footer-links">
            <div class="footer-column">
              <!-- 产品 -->
              <h3 class="footer-title">Products</h3>
              <ul class="footer-menu">
                <li>
                  <a class="cursor-pointer" @click.prevent="jumpRoute('/customerAnalysis')">
                    Customer Deep Insight
                  </a>
                </li>
                <li>
                  <a class="cursor-pointer" @click.prevent="jumpRoute('/strategyCoach')">
                    {{ $t('message.header.navList[0].children[1].children[6].name') }}
                  </a>
                </li>
                <li>
                  <a class="cursor-pointer" @click.prevent="jumpRoute('/smartPoster')">
                    {{ $t('message.header.navList[0].children[1].children[3].name') }}
                  </a>
                </li>
                <li>
                  <a class="cursor-pointer" @click.prevent="jumpRoute('/painPoints')">
                    {{ $t('message.header.navList[0].children[2].children[0].children[0].name') }}
                  </a>
                </li>
                <li>
                  <a class="cursor-pointer" @click.prevent="jumpRoute('/simulation')">
                    {{ $t('message.header.navList[0].children[2].children[0].children[1].name') }}
                  </a>
                </li>
                <li>
                  <a class="cursor-pointer" @click.prevent="jumpRoute('/solutionGenerationPlatform')">
                    {{ $t('message.header.navList[0].children[2].children[0].children[2].name') }}
                  </a>
                </li>
                <li>
                  <a class="cursor-pointer" @click.prevent="jumpRoute('/training')">
                    {{ $t('message.header.navList[0].children[2].children[0].children[3].name') }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="footer-column">
              <h3 class="footer-title">Solutions</h3>
              <ul class="footer-menu">
                <div class="d-flex">
                  <div class="list-wrap">
                    <div class="sub-title">
                      By Industry
                    </div>
                    <li>
                      <a class="cursor-pointer" @click.prevent="jumpRoute('/manufacturing')">
                        Manufacturing & Industrial
                      </a>
                    </li>
                    <li>
                      <a class="cursor-pointer" @click.prevent="jumpRoute('/automation')">
                        Automation / Robotics
                      </a>
                    </li>
                    <li>
                      <a class="cursor-pointer" @click.prevent="jumpRoute('/engineering')">
                        Engineering & Construction
                      </a>
                    </li>
                    <li>
                      <a class="cursor-pointer" @click.prevent="jumpRoute('/software')">
                        Software & IT Services
                      </a>
                    </li>
                    <li>
                      <a class="cursor-pointer" @click.prevent="jumpRoute('/logistics')">
                        Logistics & Operation Services
                      </a>
                    </li>
                    <li>
                      <a class="cursor-pointer" @click.prevent="jumpRoute('/energy')">
                        Green Energy / New Energy
                      </a>
                    </li>
                  </div>
                  <div class="list-wrap">
                    <div class="sub-title">
                      By Role
                    </div>
                    <li>
                      <a class="cursor-pointer" @click.prevent="jumpRoute('/saleTeams')">
                        Sales Teams
                      </a>
                    </li>
                    <li>
                      <a class="cursor-pointer" @click.prevent="jumpRoute('/preSaleTeams')">
                        Pre-Sales/Consultants
                      </a>
                    </li>
                    <li>
                      <a class="cursor-pointer" @click.prevent="jumpRoute('/partners')">
                        Partners/Distributors
                      </a>
                    </li>
                  </div>
                </div>
              </ul>
            </div>
            <div class="footer-column">
              <!-- 资源 -->
              <h3 class="footer-title">Resources</h3>
              <ul class="footer-menu">
                <li>
                  <a class="cursor-pointer" @click.prevent="">
                    Problems We Solve
                  </a>
                </li>
                <li>
                  <a class="cursor-pointer" @click.prevent="">
                    Knowledge Hub
                  </a>
                </li>
              </ul>
            </div>
            <div class="footer-column">
              <h3 class="footer-title" @click="jumpRoute('/pricing')">Pricing</h3>
            </div>
            <div class="footer-column">
              <h3 class="footer-title">Company</h3>
              <ul class="footer-menu">
                <li>
                  <a class="cursor-pointer" @click.prevent="jumpRoute('/About')">
                    About Us
                  </a>
                </li>
                <li>
                  <a class="cursor-pointer" @click.prevent="jumpRoute('/contact')">
                    Contact Us
                  </a>
                </li>
              </ul>
              <h3 class="footer-title cursor-pointer" @click.prevent="jumpRoute('/faq')">FAQ</h3>
              <h3 class="footer-title cursor-pointer policyAndTermsLink" @click.prevent="jumpRoute('/privacyPolicy')">{{ $t('message.privacyPolicy') }}</h3>
              <h3 class="footer-title cursor-pointer policyAndTermsLink" @click.prevent="jumpRoute('/useTerms')">{{ $t('message.terms') }}</h3>
            </div>
          </div>
        </div>
        <div class="footer-bottom d-flex align-center">
          <div class="social-links d-flex align-center">
            <a href="https://www.facebook.com/people/Xpirory/61576890436067/" target="_blank" class="social-link">
              <img src="@/assets/images/header/social-icons/Facebook.png" alt="" />
            </a>
            <a href="https://x.com/xpirory66721" target="_blank" class="social-link"><img src="@/assets/images/header/social-icons/Twitter.png" alt="" /></a>
            <a href="https://www.linkedin.com/company/xpirory/about/?viewAsMember=true" target="_blank" class="social-link"><img src="@/assets/images/header/social-icons/Instagram.png" alt="" /></a>
            <a href="https://www.youtube.com/@Xpirory" target="_blank" class="social-link">
              <img src="@/assets/images/header/social-icons/Youtube.png" alt="" />
            </a>
            <!-- <a href="" target="_blank" class="social-link"><img src="@/assets/images/header/social-icons/Instagram2.png" alt="" /></a> -->
            <!-- <a class="social-link special">
              <img src="@/assets/images/footer/whats-app.png" alt="" />
            </a> -->
          </div>
          <!-- <div class="policyAndTerms">
            <a class="cursor-pointer" @click.prevent="jumpRoute('/privacyPolicy')">{{ $t('message.privacyPolicy') }}</a>
            <a class="cursor-pointer" @click.prevent="jumpRoute('/useTerms')">{{ $t('message.terms') }}</a>
          </div> -->
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {
    currentLang: {
      type: String,
      default: 'cn',
    },
    // contact us
    contactTxt: {
      type: String,
      default: 'From Prospecting to Win—Faster with Xpirory！',
    },
    // contact us
    contactBtnTxt: {
      type: String,
      default: 'Free Trial',
    },
    contactMobileTxt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      host: '',
      advertiseImg: require('@/assets/images/header/advertise.jpg'),
      advertiseMobileImg: require('@/assets/images/header/advertise-mobile.png'),
    };
  },
  mounted() {
    this.width = document.documentElement.clientWidth;
    this.host = location.host.substring(location.host.lastIndexOf('.'));
  },
  methods: {
    dialNumber() {
      window.location.href = `tel:+8615026760702`;
    },
    // 联系我们
    contactUs() {
      // window.open('https://www.lingyao.com/');
    },
    jumpRoute(route) {
      this.$router.push(route);
      window.scrollTo(0, 0);
      localStorage.setItem('firstNavIndex', -1);
    },
    toDevelopTools(data) {
      this.$router.push(data.path);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    toSupportTools(data) {
      if (data.path) {
        this.$router.push(data.path);
      } else {
        this.$router.push(`/supportTools?activeIndex=${data.index}`);
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    // 登录
    goLogin() {
      // window.location.href = `https://user.xpirory.com/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`;
      localStorage.clear();
    },
  },
};
</script>

<style lang="scss" scoped>
.advertise-section {
  position: relative;
  padding-bottom: 0;

  .img-wrap {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .content {
    position: absolute;
    top: 59%;
    left: 160px;
    transform: translateY(-50%);

    h4 {
      font-size: 36px;
      color: var(--text-color);
      margin: 0;
      margin-bottom: 20px;
      font-weight: 500;
      line-height: 58px;
    }

    .el-button {
      border-radius: 10px;
      background-color: #1a65ff;
      padding: 12px 42px;
      font-size: 16px;
      font-family: Figtree, Arial, Helvetica;
    }

    .contact-btn {
      font-size: 20px;
      color: #fff;
      padding: 10px 50px;
      border-radius: 4px;
      border: 1px solid #fff;
      text-align: center;
      cursor: pointer;
      letter-spacing: 2px;
    }

    .contact-btn:hover {
      border-color: transparent;
    }
  }
}

.footer-wrap {
  background: url('@/assets/images/footer/footer-bg.png') center center no-repeat;
  background-size: cover;
}

.footer {
  width: 100%;
  padding-left: 160px;
  .footer-top {
    gap: 100px;
    margin-bottom: 40px;

    .logo img {
      height: 29px;
    }

    .copyright {
      font-size: 14px;
      color: var(--text-color);
      // margin-top: 10px;
      line-height: 58px;
    }

    .footer-links {
      margin-top: -13px;
      display: flex;
      flex-wrap: wrap;
      gap: 75px;
    }

    .footer-title {
      font-size: 18px;
      font-weight: 600;
      line-height: 58px;
      transition: color 0.3s;
      cursor: pointer;
      &:hover {
        color: #1867ff;
      }
      &.policyAndTermsLink {
        font-size: 14px;
      }
    }

    .sub-title {
      font-size: 14px;
      font-weight: 700;
      line-height: 32px;
    }

    .footer-menu {
      list-style: none;
      // color: #999;
      .list-wrap:first-child {
        margin-right: 35px;
      }
    }

    .footer-menu li {
      line-height: 32px;
      position: relative;
    }

    .footer-menu a {
      color: #202B52;
      text-decoration: none;
      font-size: 14px;
      transition: color 0.3s;
    }

    .footer-menu a:hover {
      color: #1867ff;
    }
  }

  .footer-bottom {
    padding-top: 32px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    gap: 90px;

    .social-links {
      width: 252px;
      gap: 16px;
    }

    .social-link {
      cursor: pointer;
      color: #999;
      font-size: 18px;
      transition: color 0.3s;
      &.special {
        position: relative;
        &:hover .hover-img {
          display: block;
        }
      }
      .hover-img {
        display: none;
        position: absolute;
        top: -110px;
        width: 100px !important;
        height: 100px;
        transform: translateX(-35%);
      }
    }

    .policyAndTerms {
      margin-left: -330px;
      a {
        color: #999;
        text-decoration: none;
        font-size: 14px;
        transition: color 0.3s;
        &:first-child {
          margin-right: 146px;
        }
        &:hover {
          color: #1867ff;
        }
      }
    }

    .social-link:hover {
      color: #1867ff;
    }

    .social-link {
      img {
        width: 42px;
      }
    }

    .login-link {
      img {
        width: 12px;
        font-size: 14px;
      }
    }
  }
}

.copyright-link {
  margin-top: 10px;
  a {
    text-decoration: none;
    cursor: pointer;
    color: #fffefe;
    font-size: 14px;
    transition: color 0.3s;
    &:hover {
      color: #1867ff;
    }
  }
}
</style>
